import React from "react"
import { useFormContext } from "react-hook-form"

import {
  Box,
  FormControlLabel,
  Checkbox,
  makeStyles,
  Theme,
  FormGroup,
  OutlinedInput,
  FormHelperText,
} from "@material-ui/core"
import { InputLabel } from "../@citydna/common/InputLabel"

import { useCommonFieldProps } from "./CommonFieldPropsContext"
import { CommonFieldFields } from "./CommonFieldFields"
import { CommonFieldOptions } from "./CommonFieldOptions"

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  root: {},
  fields: {
    marginRight: theme.spacing(4),
    paddingRight: theme.spacing(5),
    flexGrow: 1,
    borderRight: `1px solid ${
      theme.palette.type === "dark"
        ? theme.palette.grey[500]
        : theme.palette.grey[100]
    }`,
  },
  helperText: {
    fontSize: 10,
  },
}))

export const DropdownFieldFields: React.FC = () => {
  /** Get common field props */
  const { index, field } = useCommonFieldProps()

  /** Get scoped CSS classes */
  const classes = useStyles()

  const { register, errors } = useFormContext()
  const prefix = `fields[${index}]`
  const optionsInputName = `${prefix}.options`
  const subvariantInputName = `${prefix}.subvariant`

  return (
    <Box display="flex">
      <Box className={classes.fields}>
        <CommonFieldFields />
        <Box>
          <InputLabel htmlFor={optionsInputName}>Dropdown options</InputLabel>
          <OutlinedInput
            inputRef={register({ required: true })}
            name={optionsInputName}
            id={optionsInputName}
            defaultValue={field.options || ""}
            fullWidth
            color="secondary"
            error={errors[optionsInputName]}
          />
          <FormHelperText className={classes.helperText}>
            comma separated values
          </FormHelperText>
        </Box>
      </Box>
      <Box className={classes.options}>
        <InputLabel htmlFor={subvariantInputName}>Field options</InputLabel>
        <FormGroup>
          <FormControlLabel
            className={classes.formControl}
            control={
              <Checkbox
                inputRef={register()}
                name={subvariantInputName}
                value="multiselect"
                defaultChecked={field.subvariant === "multiselect"}
              />
            }
            label="Multi-select"
          />
          <CommonFieldOptions />
        </FormGroup>
      </Box>
    </Box>
  )
}
